import { Section } from '@/components/layout';
import { Reveal } from '@/components/motion';
import { ResponsiveImage } from '@/components/media';
import { OndaCorazon } from '../icons/BogotaIcons';
import styles from './MantraBogota.module.css';

/* =============================================================================
 * S5 · MANTRA DE CIERRE  (mockup y 1376–1536 · 89,6–100 % del alto)
 * -----------------------------------------------------------------------------
 * Banda a sangre con la panorámica de los cerros y la ciudad, y el mantra
 * centrado sobre la zona luminosa.
 *
 * Las tres líneas tienen el MISMO cuerpo y el mismo ritmo: la jerarquía la da el
 * color (dos en navy, la tercera en oro), no el tamaño. Calcado del mockup.
 * ========================================================================== */
export function MantraBogota() {
  return (
    <Section
      background="none"
      spacing="flush"
      width="full"
      labelledBy="bogota-mantra"
      className={styles.section}
    >
      <div className={styles.band}>
        <ResponsiveImage
          asset="bogota/cierre-panorama"
          className={styles.bg}
          sizes="100vw"
          decorative
        />
        <span className={styles.veil} aria-hidden="true" />

        <Reveal className={styles.contentWrap}>
          <div className={styles.content}>
            <h2 id="bogota-mantra" className={styles.mantra}>
              <span className={styles.line}>Recuerda.</span>
              <span className={styles.line}>Sana.</span>
              <span className={styles.lineGold}>Vuelve a casa.</span>
            </h2>

            <OndaCorazon className={styles.wave} />

            <p className={styles.farewell}>Te esperamos.</p>
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
